






























































import { Component, Vue, Prop } from 'vue-property-decorator';

import tippy from 'tippy.js';
import { EnrolProfile } from '@/types';

@Component({
  components:{
    
  }
})
export default class EnrolProfileRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) enrolProfile!: EnrolProfile;
  @Prop({ default: () => [],  type: Array}) usedEnrolIdList!: string[];

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
    
  async mounted() {
    tippy('[data-tippy-content]');
  }

  get canDelete():boolean {
    return !this.usedEnrolIdList.some(enrolId => enrolId === this.enrolProfile.enrolId);
  }
}

